import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function Home() {
    return (
        <Paper>
            <Typography variant="h4" gutterBottom>Welcome to iQ</Typography>
        </Paper>
    );
}